// Click sulla riga di un elenco → modale di dettaglio [sc-48893].
// Condiviso da Clienti, Preventivi, Magazzino e Listini: la pagina passa il
// titolo e una funzione che restituisce i gruppi (anche asincrona, per gli
// articoli che si rileggono da `item/:id`).

import axiosInstance from "@/axiosInstance";
import { clickApreDettaglio, dettaglioArticolo } from "@/utilities/dettaglio";

export default {
  data() {
    return {
      dettaglio: { show: false, titolo: "", gruppi: [], loading: false },
      dettaglioRichiesta: 0,
    };
  },
  methods: {
    async apriDettaglio(event, titolo, costruisci) {
      if (!clickApreDettaglio(event)) return;
      // una sola risposta vale: quella dell'ultima riga aperta
      const richiesta = ++this.dettaglioRichiesta;
      this.dettaglio = { show: true, titolo, gruppi: [], loading: true };
      try {
        const gruppi = await costruisci();
        if (richiesta === this.dettaglioRichiesta)
          this.dettaglio.gruppi = gruppi;
      } catch (err) {
        if (richiesta !== this.dettaglioRichiesta) return;
        this.dettaglio.show = false;
        this.$toast.error(
          err?.response?.data?.message ||
            "Errore nel caricamento del dettaglio."
        );
      } finally {
        if (richiesta === this.dettaglioRichiesta)
          this.dettaglio.loading = false;
      }
    },

    // La riga dell'elenco non ha tutti i campi dell'articolo: si rilegge
    apriDettaglioArticolo(event, item) {
      return this.apriDettaglio(
        event,
        item.itemName || item.itemCode,
        async () => {
          const { data } = await axiosInstance.get(`/item/${item.id}`);
          return dettaglioArticolo({ ...item, ...data.item });
        }
      );
    },
  },
};
